export const getCapitalizeLetters = (letters: string) =>
  letters.charAt(0).toUpperCase() + letters.slice(1).toLowerCase();
